import React from 'react';
import PropTypes from 'prop-types';
import './CardHeader.css';

export default class CardHeader extends React.Component {

    render() {
        const {
            title,
            message,
            subtitle,
            rightOptions,
        } = this.props;

        return (
            <div className="header">
                <div className={"header-container"}>
                    <div>
                        <h2>{title} <small>{subtitle}</small></h2>
                    </div>
                    <div>
                        {rightOptions}
                    </div>
                </div>
                {
                    message ? <p><small>{message}</small></p> : null
                }
            </div>
        );
    }

}

CardHeader.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    message: PropTypes.string,
    rightOptions: PropTypes.any,
};

CardHeader.defaultProps = {
    title: '',
};



// WEBPACK FOOTER //
// ./src/app/shared/components/card-header/CardHeader.jsx